export enum EFeatureFlag {
  ContentLibrary = 'contentLibrary',
  EditNonSignableAfterSent = 'editNonSignableAfterSend',
  GlobalNavigation = 'globalNavigation',
  EditorInputField = 'editorInputField',
}
